import { motion } from "framer-motion";
import { Heart, DollarSign, Briefcase, Sparkles } from "lucide-react";
import { NetworkCard } from "./NetworkCard";

const SITES = [
  {
    id: 1,
    name: "Routine Mindful Care",
    url: "https://livelifeunbound.site",
    description:
      "Wellness and mindfulness resources for living an intentional, balanced life. Focus on self-care, mental health, and daily routines.",
    icon: <Heart className="w-6 h-6" />,
    color: "from-cyan-500 to-teal-500"
  },
  {
    id: 2,
    name: "Real Money Creation",
    url: "https://rmcwealth.online",
    description:
      "Wealth building strategies, financial education, and proven methods for creating real income streams online.",
    icon: <DollarSign className="w-6 h-6" />,
    color: "from-green-600 to-emerald-500"
  },
  {
    id: 3,
    name: "Reliable Marketing Concepts",
    url: "https://rmcbiz.website",
    description:
      "Marketing strategies, business concepts, and proven frameworks for growing your online presence and revenue.",
    icon: <Briefcase className="w-6 h-6" />,
    color: "from-blue-600 to-sky-500"
  },
  {
    id: 4,
    name: "Ready Made Content",
    url: "https://livelifeunbound.com",
    description:
      "Pre-made content, templates, and resources to accelerate your content creation and marketing efforts.",
    icon: <Sparkles className="w-6 h-6" />,
    color: "from-blue-600 to-red-500"
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

export const RMCNetwork = () => {
  return (
    <section
      id="network"
      className="py-20 sm:py-24 lg:py-32 bg-[hsl(var(--background))]"
      data-testid="network-section"
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-10 max-w-7xl">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mb-4" data-testid="network-title">
            RMC Network
          </h2>
          <p className="text-lg text-[hsl(var(--muted-foreground))] max-w-3xl mx-auto" data-testid="network-subtitle">
            Four specialized platforms designed to help you live life unbound through wellness, wealth, marketing, and content
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid sm:grid-cols-2 gap-6"
          data-testid="network-grid"
        >
          {SITES.map((site, index) => (
            <NetworkCard key={site.id} site={site} index={index} />
          ))}
        </motion.div>

        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
          className="mt-16 text-center"
        >
          <p className="font-mono text-sm text-[hsl(var(--muted-foreground))]">
            Building a network of resources to help you achieve financial freedom and live life on your terms
          </p>
        </motion.div>
      </div>
    </section>
  );
};
